<template>
	<div class="logo">
		<img :src="logo" alt="sponsor" />
	</div>
</template>
<script>
export default {
	props: {
		logo: {
			type: String,
			required: true
		}
	}
};
</script>
<style lang="scss" scoped>
.logo {
	height: 100%;
	display: flex;
	align-items: center;
	img {
		display: block;
		max-height: 48px;
		margin-top: 4px;
	}
}
</style>
